import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "form-header" }, "Password reset", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  class: "form-control mt-3",
  id: "inputEmail",
  placeholder: "Email Address"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "btn-submit w-100 mt-3" }, "Submit", -1)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_7 = { class: "need-account-link" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Don't have an account?   ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Sign up for free")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_form_container = _resolveComponent("login-form-container")!

  return (_openBlock(), _createBlock(_component_login_form_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", null, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "grey-form-link",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_router_link, {
          to: "/signup",
          class: "signup-now-link"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}